import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import DependencyManager from "../../DependencyManager";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import withConfig from "../../ComponentDependency/withConfig";
var css = {
  "wrapper": "oalp-3f_fy",
  "mobile": "oalp-1nFow",
  "desktop": "oalp-2Far2",
  "leftWrapper": "oalp-H3rN1",
  "textBanner": "oalp-1zW_k",
  "carBanner": "oalp-1nr8-"
};
import { DESKTOP } from "../../Constants/platform";
export var CfWidgetWrapper = function CfWidgetWrapper(_ref) {
  var data = _ref.data,
    config = _ref.config,
    CFWidget = _ref.CFWidget,
    metadata = _ref.metadata,
    track = _ref.track,
    origin = _ref.origin;
  var _ref2 = data || {},
    props = _ref2.props;
  var _ref3 = metadata || {},
    _ref3$banner = _ref3.banner,
    carBanner = _ref3$banner.carBanner,
    textBanner = _ref3$banner.textBanner;
  var _a = props || {},
    _a$item = _a.item,
    item = _a$item === void 0 ? {
      id: 'CFTAB_HOMEPAGE'
    } : _a$item,
    _a$page = _a.page,
    page = _a$page === void 0 ? 'CF_TAB_HOMEPAGE' : _a$page,
    rest = __rest(_a, ["item", "page"]);
  var PanameraConstants = DependencyManager.getDependency('constants');
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.wrapper, css[PanameraConstants.platform])
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.leftWrapper, css[PanameraConstants.platform])
  }, textBanner && /*#__PURE__*/React.createElement(ImageWrapper, {
    className: css.textBanner,
    image: {
      url: textBanner.url,
      style: textBanner.style
    }
  }), carBanner && carBanner.url && /*#__PURE__*/React.createElement(ImageWrapper, {
    className: classnames(_defineProperty({}, css.carBanner, PanameraConstants.platform === DESKTOP)),
    image: carBanner
  })), /*#__PURE__*/React.createElement("div", {
    className: css.rightWrapper
  }, CFWidget ? /*#__PURE__*/React.createElement(CFWidget, Object.assign({
    item: item,
    onTrack: track,
    config: config,
    origin: origin,
    page: page
  }, rest)) : null));
};
export default compose(withComponentDependency, withConfig)(CfWidgetWrapper);